import { render } from "./ToastNotification.vue?vue&type=template&id=06882a70&scoped=true"
import script from "./ToastNotification.vue?vue&type=script&lang=js"
export * from "./ToastNotification.vue?vue&type=script&lang=js"

import "./ToastNotification.vue?vue&type=style&index=0&id=06882a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06882a70"]])

export default __exports__